/** How much of the inbound a turn stamp keeps for the session details header. */
export const GRAPH_TURN_INBOUND_TEXT_LENGTH = 280;
function clip(value, length) {
    const line = value.replace(/\s+/g, ' ').trim();
    return line.length > length ? `${line.slice(0, length).trimEnd()}…` : line;
}
/** The start of an inbound, as the session row and session details keep it. */
export function clipInboundText(value) {
    return clip(value, GRAPH_TURN_INBOUND_TEXT_LENGTH);
}
export function graphTurnStamp(input) {
    return {
        turnId: input.turnId,
        inboundText: clipInboundText(input.inboundText),
        receivedAt: input.receivedAt.toISOString(),
        sentAt: input.sentAt.toISOString(),
        inboundExternalMessageId: input.inboundExternalMessageId,
        outboundExternalMessageId: input.outboundExternalMessageId,
    };
}
/** The turn stamp a record carries, or null when the record has none. */
export function turnStampOf(record) {
    if (!record)
        return null;
    const { turnId, inboundText, receivedAt, sentAt, inboundExternalMessageId, outboundExternalMessageId, } = record;
    if (typeof turnId !== 'string' ||
        typeof inboundText !== 'string' ||
        typeof receivedAt !== 'string' ||
        typeof sentAt !== 'string') {
        return null;
    }
    return {
        turnId,
        inboundText,
        receivedAt,
        sentAt,
        inboundExternalMessageId: typeof inboundExternalMessageId === 'string'
            ? inboundExternalMessageId
            : null,
        outboundExternalMessageId: typeof outboundExternalMessageId === 'string'
            ? outboundExternalMessageId
            : null,
    };
}
/** The wall time of a turn in milliseconds, from the inbound to the reply. */
export function turnWallMs(stamp) {
    return new Date(stamp.sentAt).getTime() - new Date(stamp.receivedAt).getTime();
}
//# sourceMappingURL=turn-stamp.js.map